import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Influencer} from '../../../../../models/influencer';
import {CommonConstant, listOrderedPlatforms} from '../../../../app.constants';
import {UserService} from '../../../../services/user.service';
import {FilterSearch} from '../../../../../models/filter-search';

@Component({
  selector: 'preview-influencer-item',
  templateUrl: './preview-influencer-item.component.html',
  styleUrls: ['./preview-influencer-item.component.scss']
})
export class PreviewInfluencerItemComponent {

  @Input()
  public evenRow: boolean | false;
  @Input()
  public previewedMode: boolean | false;
  @Input()
  public influencer: Influencer = new Influencer();
  @Input()
  public discoverFilter: FilterSearch;
  @Input()
  public displayInfo: string | '';
  @Output()
  public selectedInfluencer: EventEmitter<any> = new EventEmitter<any>();

  // TODO update this number when API is ready for influencer_group_id
  public influencerGroupId = 0;
  public platformList = [];

  constructor( private userService: UserService ) {
    this.platformList = listOrderedPlatforms;
  }

  hasInfluencerData(): boolean {
    return this.influencer !== undefined;
  }

  onSelectedInfluencer(influencer, e) {
    if (this.previewedMode) {
      influencer.previewed = !influencer.previewed;
    } else {
      influencer.selected = !influencer.selected;
    }
    e.stopPropagation();
    this.selectedInfluencer.emit(influencer);
  }

  getInfluencerHandle(selectedInfluencer) {
    if (this.displayInfo === 'posts') {
      return selectedInfluencer.influencer_name;
    }
    if (Array.isArray(selectedInfluencer.channels) && selectedInfluencer.channels.length > 0) {
      return selectedInfluencer.channels[0].handle;
    } else {
      return selectedInfluencer.relativePath;
    }
  }

  hasPlatform(platformId, influencer) {
    if (!influencer || !influencer.channels) {
      return false;
    }

    return influencer.channels.findIndex((channel) => channel.platform.id === platformId) >= 0;
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  getPreviewedItemTitle(influencer) {
    return this.displayInfo === 'posts' ? influencer.title : influencer.influencer_name;
  }

  getCountryCode(influencer) {
    return influencer && influencer.country_code ? influencer.country_code.toLowerCase() : CommonConstant.INTERNATION_COUNTRY_CODE;
  }

  get entryLink() {
    if (this.displayInfo === 'posts') {
      return ['/post/'];
    } else {
      return ['/influencer/' + this.influencer.influencer_id + '/overview'];
    }
  }

  get linkParams() {
    let params = {
      group_id: this.influencerGroupId,
      activeAccount: this.activeAccount,
      hideBackButton: true,
      influencerId: undefined,
      fullUrl: undefined,
      relativePath: undefined,
      urlHash: undefined
    };

    if (this.displayInfo === 'posts') {
      params.influencerId = this.influencer.id;
      params.fullUrl = this.influencer.url;
      params.relativePath = this.influencer.relativepath;
      params.urlHash = this.influencer.urlHash;
    }

    if (this.discoverFilter && this.discoverFilter.audienceFilters.length > 0) {
      params = Object.assign({}, params, {
        target: 'discover'
      });
    }

    return params;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/group-details/preview-selected-influencers/preview-influencer-item/preview-influencer-item.component.ts